import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PageRequest } from '@models/models';

@Injectable()
export class DashboardDataServiceProvider {
	constructor(public http: HttpClient) {}

	getShootsAppointmentsData(paginationRules: PageRequest) {
		const url = '/api/user/v1/events';
		return this.http.post(url, paginationRules);
	}

	getUpcomingPaymentsData(paginationRules: PageRequest) {
		const url = '/api/user/v1/payment';
		return this.http.post(url, paginationRules);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/services/dashboard/dashboard.data.service.ts